module.exports = __webpack_public_path__ + "img/send.9e205be8.svg";